module.exports = "<div class=\"menu-item\"\r\n     [ngClass]=\"{'menu-item-active': isActiveMenuItem }\">\r\n    <span class=\"menu-item-text\">{{ subitem.text.toUpperCase() }}</span>\r\n    <img [src]=\"'../../assets/images/BtnNext.png'\" class=\"menu-item-icon\">\r\n</div>\r\n<div class=\"menu-item-bottomline\">\r\n\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/submenu-item.component.html
// module id = 2140
// module chunks = 1